module.exports = __webpack_public_path__ + "static/media/whyus.52dcc16f.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/whyus.png
// module id = 138
// module chunks = 0